import { useMemo } from "react";

import { useFastshiftSelector } from "@/state";

import { BaseIdentityAttrs } from "../types";

export const useBaseIdentityAttrs = (): BaseIdentityAttrs | null => {
    const { data: userDetails } = useFastshiftSelector(
        (state) => state.userDetails
    );

    return useMemo(() => {
        if (!userDetails) return null;
        return {
            role: userDetails.userType,
            userDomain: userDetails.userDomain.domain
        };
    }, [userDetails]);
};
